import { useTranslation } from 'react-i18next';
import type { Screen } from '@ghostscreen/contracts';

type PairScreenPickerProps = {
  screens: Screen[];
  selectedId: string | null;
  onSelect: (screenId: string) => void;
};

export function PairScreenPicker({ screens, selectedId, onSelect }: PairScreenPickerProps) {
  const { t } = useTranslation('displays');
  return (
    <ul className="m-0 flex list-none flex-col gap-2 p-0">
      {screens.map((screen) => {
        const selected = screen.id === selectedId;
        const unpaired = screen.deviceId == null;
        return (
          <li key={screen.id}>
            <button
              type="button"
              onClick={() => onSelect(screen.id)}
              className="flex w-full items-center justify-between gap-3 rounded-[12px] border px-3.5 py-3 text-start"
              style={{
                color: 'var(--gs-ink)',
                background: selected ? 'var(--gs-panel2)' : 'var(--gs-panel)',
                borderColor: selected ? 'var(--gs-accent)' : 'var(--gs-line)',
                fontFamily: 'inherit',
              }}
            >
              <span className="flex min-w-0 flex-col gap-0.5">
                <span className="truncate text-[15px] font-bold">{screen.name}</span>
                <span className="text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
                  {unpaired ? t('pair.picker.notConnected') : t('pair.picker.willReplace')}
                </span>
              </span>
              <span
                className="grid h-5 w-5 shrink-0 place-items-center rounded-full border text-[11px] font-bold"
                style={{
                  borderColor: selected ? 'var(--gs-accent)' : 'var(--gs-line)',
                  background: selected ? 'var(--gs-accent-solid)' : 'transparent',
                  color: selected ? 'var(--gs-accent-ink)' : 'transparent',
                }}
                aria-hidden
              >
                ✓
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
